import { render, staticRenderFns } from "./GridCompetencyForm.vue?vue&type=template&id=311373c5"
import script from "./GridCompetencyForm.vue?vue&type=script&lang=js"
export * from "./GridCompetencyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports